import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { m } from 'framer-motion';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Container, Stack, IconButton } from '@mui/material';
// components
import { useSettingsContext } from '../../../components/minimal/settings/index.jsx';
import SvgColor from '../../../components/minimal/svg-color/index.jsx';
import Image from '../../../components/minimal/image/index.jsx';
import { MotionViewport, varFade } from '../../../components/minimal/animate/index.jsx';
import MainImg from '../../../assets/images/home/new.png'
import { Link as RouterLink } from 'react-router-dom';
import { maxHeight, width } from '@mui/system';
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(10, 0),
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundImage: `url('/assets/background/overlay_2.jpg')`,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(20, 0),
  },
}));

// ----------------------------------------------------------------------

export default function CustomerClubSection() {

  return (
    <StyledRoot sx={{ mt: 10 }}>
      <Container component={MotionViewport}>
        <m.div variants={varFade().inUp}>
          <Typography variant="h3" component="h1" gutterBottom>
            מועדון חברים
            <br />
            מחברים בין אירועים לאנשים
          </Typography>
        </m.div>
        <Stack spacing={2} direction={
          { xs: 'column-reverse', sm: 'row' }
        } display="flex" justifyContent={'space-between'} alignItems={'center'}>
          <Box component={MotionViewport} sx={{
            maxWidth: { sm: '100%', md: '600px' },
          }}>
            <m.div variants={varFade().inUp}>
              <Typography variant="h6" component="p" gutterBottom>
                הפכו את הקהל שלכם לקהילה נאמנה עם מנויים, כרטיסיות והטבות בלעדיות לחברים.
              </Typography>
            </m.div>

            <m.div variants={varFade().inUp}>
              <Typography variant='p'>
                נימי הופכת כל עסק של אירועים והפקות לקהילה חיה ונושמת!
                <br />
                בעזרת פיצ'ר מועדון החברים תוכלו להציע מנויים שנתיים, כרטיסיות כניסה, והטבות מיוחדות לחברים ולממליצים.
                <br />
                יצירת מועדון חברים מעניקה לקהל שלכם תחושת שייכות וחוסכת לכם מאמצי שיווק - כשהקהילה שלכם פועלת בשבילכם.

              </Typography>
            </m.div>

            <m.div variants={varFade().inUp}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ mt: 2 }}
                // href="/clubs"
                component={RouterLink}
                to="/clubs"
              >
                קראו עוד על מועדון הלקוחות שלנו
              </Button>
            </m.div>
          </Box>
          <Box component={MotionViewport} sx={{
            maxWidth: { sm: '100%', md: '400px' },
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: (theme) => `-40px 40px 80px ${alpha(theme.palette.common.black, 0.24)}`,
          }}>
            <m.div variants={varFade().inUp}>
              <Image
                alt="darkmode"
                src={'/assets/images/home/2149052766.jpg'}
              />
            </m.div>
          </Box>
        </Stack>
      </Container>
    </StyledRoot>
  );
}
